<template>
  <div v-if="error" class="e-error content">
    <template v-if="isAutorisationError">
      <p>
        Требуется авторизоваться заново, <router-link :to="{path: '/login'}">
        перейти к странице авторизации
      </router-link>
      </p>
    </template>
    <template v-else>
      <h1>{{error.title}}</h1>
      <div v-if="error.message" v-html="error.message"></div>
      <p v-if="error.apiUrl">
        URL api вызвавший ошибку: {{error.apiUrl}}
      </p>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'e-error',
    props: ['error'],
    computed: {
      isAutorisationError () {
        return this.error && this.error.status === 401
      }
    }
  }
</script>
